(function () {
	const splitIntoWords = (text) => {
		return text
			.split(/(\s+)/)
			.map((word) =>
				word.trim()
					? `<span class="word"><span class="word-inner">${word}</span></span>`
					: " "
			)
			.join("");
	};

	const prepareSlideContent = (slide, speed) => {
		slide
			.querySelectorAll(".animated-lines .line-inner")
			.forEach((lineInner) => {
				lineInner.style.transform = "translateY(0)";
				lineInner.innerHTML = splitIntoWords(lineInner.textContent);

				lineInner.querySelectorAll(".word-inner").forEach((word) => {
					word.style.transition = `transform ${speed}ms ease`;
				});
			});

		// Setup fade elements
		slide.querySelectorAll(".fade-element").forEach((element) => {
			element.style.transition = `opacity ${speed}ms ease`;
			element.style.opacity = slide.classList.contains("swiper-slide-active")
				? "1"
				: "0";
		});
	};


	const slideshow = () => {
		$(".slideshow-section").each(function () {
			if ($(this).hasClass("slider_started")) {
				return "";
			}
			$(this).addClass("slider_started");
			const id = $(this).attr("id");
			const box = $(this).find(".slideshow");
			const autoplay = box.data("autoplay");
			const stopAutoplay = box.data("stop-autoplay");
			const delay = box.data("delay") * 1000;
			const speed = box.data("speed") * 1000;
			const slideCount = parseInt(box.data("count"));
			const loop = slideCount > 1;
			const animation = box.data("animation") || 'fade';

			const swiperParms = {
				speed: speed,
				slidesPerView: 1,
				spaceBetween: 0,
				loop: loop,
				loopedSlides: slideCount,
				keyboard: true,
				observer: true,
				observeParents: true,
				watchSlidesProgress: true,
				preventInteractionOnTransition: true,
			};

			const swiperImg = new Swiper(`#${id} .slideshow__swiper_img`, {
				...swiperParms,
				effect: animation,
				fadeEffect: { crossFade: true },
				creativeEffect: {
					prev: {
						shadow: true,
						translate: ['-20%', 0, -1],
						scale: 1.2
					},
					next: {
						translate: ['100%', 0, 0],
					},
				},
				allowTouchMove: false,
			});

			const swiperText = new Swiper(`#${id} .slideshow__swiper_text`, {
				...swiperParms,
				autoplay: autoplay ? {
					delay: delay,
					pauseOnMouseEnter: stopAutoplay,
					disableOnInteraction: false,
				} : false,
				effect: animation === 'creative' ? 'fade' : animation,
				fadeEffect: { crossFade: true },
				navigation: {
					nextEl: `#${id} .swiper-btn--next`,
					prevEl: `#${id} .swiper-btn--prev`,
				},
				pagination: {
					el: `#${id} .swiper-pagination`,
					renderBullet: function (index, className) {
						return (
							'<span class="' + className + '">' + "0" + (index + 1) + "</span>"
						);
					},
				},
				on: {
					init: function () {
						this.slides.forEach((slide) => {
							prepareSlideContent(slide, speed);
						});

						// Initialize animations for first slide
						const currentSlide = this.slides[this.activeIndex];
						if (!currentSlide) return;

						currentSlide.querySelectorAll(".word-inner").forEach((word) => {
							word.style.transition = "none";
							word.style.transform = "translateY(100%)";
							void word.offsetWidth;
							word.style.transition = `transform ${speed / 1000}s ease`;
							word.style.transform = "translateY(0)";
						});

						currentSlide.querySelectorAll(".fade-element").forEach((element) => {
							element.style.transition = "none";
							element.style.opacity = "0";
							void element.offsetWidth;
							element.style.transition = `opacity ${speed / 1000}s ease`;
							element.style.opacity = "1";
						});

						colorScheme(this);
					},
					slideChange: function () {
						const prevSlide = this.slides[this.previousIndex];
						const nextSlide = this.slides[this.activeIndex];
					
						if (prevSlide) {
							prevSlide.querySelectorAll(".fade-element").forEach((element) => {
								element.style.opacity = "0";
							});
							prevSlide.querySelectorAll(".word-inner").forEach((word) => {
								word.style.transition = "none";
								word.style.transform = "translateY(0)";
								void word.offsetWidth;
								word.style.transition = `transform ${speed / 1000}s ease`;
								word.style.transform = "translateY(-100%)";
							});
						}

						if (nextSlide) {
							nextSlide.querySelectorAll(".fade-element").forEach((element) => {
								element.style.opacity = "1";
							});
							nextSlide.querySelectorAll(".word-inner").forEach((word) => {
								word.style.transition = "none";
								word.style.transform = "translateY(100%)";
								void word.offsetWidth;
								word.style.transition = `transform ${speed / 1000}s ease`;
								word.style.transform = "translateY(0)";
							});
						}

						colorScheme(this);
					},
					slideChangeTransitionStart: function (swiper) {
						box.css("--bullet-duration", `${delay + speed}ms`);
						let bullets = box[0].querySelectorAll(".swiper-pagination-bullet");
						let activeIndex = swiper.realIndex;
						bullets.forEach((bullet, index) => {
							bullet.classList.remove("prev", "next");
							if (index === activeIndex - 1) bullet.classList.add("prev");
							if (index === activeIndex + 1) bullet.classList.add("next");
						});
					},
					slideNextTransitionStart: function () {
						let bullet = box[0].querySelector(".swiper-pagination-bullet.next");
						if (autoplay && bullet) {
							bullet.classList.add('opacity-0');
							setTimeout(() => bullet.classList.remove('opacity-0'), speed);
						}
					},
					slidePrevTransitionStart: function () {
						let bullet = box[0].querySelector(".swiper-pagination-bullet.prev");
						if (!autoplay && bullet) {
							bullet.classList.add('opacity-0');
							setTimeout(() => bullet.classList.remove('opacity-0'), speed);
						}
					},
				},
			});
			
			swiperText.controller.control = swiperImg;

			function colorScheme(context) {
				const parent = box.find(".slideshow-bottom");
				const activeIndex = context.activeIndex;
				const activeSlide = context.slides[activeIndex];
				if (!activeSlide) return;

				const colorScheme = $(activeSlide).find("[data-color-scheme]").first().data("color-scheme");
				if (colorScheme) {
					parent.removeClass(function (index, className) {
						return (className.match(/(^|\s)color-background-\d+/g) || []).join(' ');
					}).addClass(colorScheme);
				}
			}
		});
	};

	slideshow();
	
	document.addEventListener('shopify:section:load', function () {
		slideshow();
	});
})();
